import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AdminState } from "../../types";
import { axiosObj } from "../../../config/apiClients";
import { Admin, AdminPermissions } from "../../../utils/types";

const initialState: AdminState = {
  isLoading: false,
  admin: null,
  admins: [],
  adminPermissions: null,
}

export const getAllAdmins = createAsyncThunk(
  "/permissions/getAllAdmins",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosObj.get('/permissions/getAllAdmins');
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch All Admins' });
    }
  }
)

export const createAdmin = createAsyncThunk(
  "/permissions/createAdmins",
  async (admin: Admin, { rejectWithValue }) => {
    try {
      const response = await axiosObj.post('/auth/register', admin);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to create Admin' });
    }
  }
)

export const createPermissions = createAsyncThunk(
  "/permissions/update",
  async (permissions: AdminPermissions, { rejectWithValue }) => {
    try {
      const response = await axiosObj.patch('/permissions/update', permissions);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to update Permissions' });
    }
  }
)

export const getAdminPermissions = createAsyncThunk(
  "/permissions/getById",
  async (adminId: string, { rejectWithValue }) => {
    try {
      const response = await axiosObj.post('/permissions/getById', { adminId });
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch All Admins' });
    }
  }
)

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setAdmin: (state, action) => {
      state.admin = action.payload;
    },
    resetAdmin: (state) => {
      state.admin = null;
      state.adminPermissions = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllAdmins.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllAdmins.fulfilled, (state, action) => {
        state.isLoading = false;
        state.admins = action.payload.payload.allAdmins;
      })
      .addCase(getAllAdmins.rejected, (state) => {
        state.isLoading = false;
        state.admins = [];
      })
      .addCase(getAdminPermissions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAdminPermissions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.adminPermissions = action.payload.payload.adminPermissions;
      })
      .addCase(getAdminPermissions.rejected, (state) => {
        state.isLoading = false;
        state.adminPermissions = null;
      });
  }
});

export const { setAdmin, resetAdmin } = adminSlice.actions;

export default adminSlice.reducer;